import React from 'react';

const CHUNK_LOAD_ERROR = /Failed to fetch dynamically imported module|Loading chunk|Importing a module script failed/i;

export function lazyWithRetry<T extends React.ComponentType<any>>(
    importer: () => Promise<{ default: T }>,
    retryKey: string
) {
    return React.lazy(() =>
        importer().catch((error) => {
            const message = error instanceof Error ? error.message : String(error);
            if (CHUNK_LOAD_ERROR.test(message)) {
                let hasRetried = false;
                try {
                    hasRetried = sessionStorage.getItem(retryKey) === '1';
                } catch {
                    hasRetried = false;
                }
                if (!hasRetried) {
                    try {
                        sessionStorage.setItem(retryKey, '1');
                    } catch {
                        // Best effort: skip storage if unavailable.
                    }
                    window.location.reload();
                }
            }
            return Promise.reject(error);
        })
    );
}
